module.exports = __webpack_public_path__ + "img/3.a2ab6cc2.jpg";